import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { initSentry } from './sentry';
import './i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Initialize error tracking before anything else renders so that
// init-time errors in App are captured.
initSentry();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Register the service worker so web push can wake the app even when no tab
// is open. Production only - CRA's dev server interferes with SW caching.
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(err => {
      console.warn('Service worker registration failed:', err);
    });
  });
}
